import React, { useState, useEffect } from "react";
import classNames from "classnames";
import styles from "./toggle.module.scss";

export type ToggleProps = {
  toggleSize?: "small" | "xsmall";
  className?: string;
  defaultChecked?: boolean;
  children?: never;
  onStateChange?: (arg0: boolean) => void;
} & React.InputHTMLAttributes<HTMLInputElement>;

const Toggle = React.forwardRef<HTMLInputElement, ToggleProps>(
  (
    {
      toggleSize = "small",
      className = "",
      defaultChecked = false,
      onStateChange = () => {},
      ...props
    }: ToggleProps,
    ref
  ) => {
    const [isActive, setIsActive] = useState(defaultChecked);

    useEffect(() => {
      onStateChange(isActive);
    }, [isActive, onStateChange]);

    return (
      <input
        ref={ref}
        type="checkbox"
        className={classNames(styles.toggle, className)}
        checked={isActive}
        data-size={toggleSize}
        onChange={() => setIsActive(!isActive)}
        {...props}
      />
    );
  }
);

export default Toggle;
